import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { ConfigurationDetailsComponent } from 'src/app/components/configuration-details/configuration-details.component';
import { SidenavService } from 'src/app/services/util/sidenav.service';

@Component({
    selector: 'app-select-database',
    templateUrl: './select-database.component.html',
    styleUrls: ['./select-database.component.scss'],
    standalone: false
})
export class SelectDatabaseComponent implements OnInit {

  backupResults: any;
  server: string;
  displayColumns = [
    {
      key: 'selected',
      name: '',
      type: 'radioSelection',
      sortable: false,
      visible: true
    },
    {
      key: 'name',
      name: translate('INSTANCE_DETAILS.DATABASE_NAME'),
      type: 'text',
      hasInfoIcon: true,
      sortable: true,
      visible: true
    },
    {
      key: 'pitrTimestamp',
      name: translate('INSTANCE_DETAILS.PITR_UTC'),
      type: 'date',
      sortable: true,
      visible: true
    },
    {
      key: 'solutionReleaseVersion',
      name: translate('INSTANCE_DETAILS.SOLUTION_VERSION'),
      type: 'text',
      sortable: true,
      visible: true
    },
    {
      key: 'configurationVersion',
      name: translate('INSTANCE_DETAILS.RELEASE_PACKAGE_VERSION'),
      type: 'text',
      sortable: true,
      visible: true
    },
    {
      key: 'createdAt',
      name: translate('INSTANCE_DETAILS.CREATED_DATE_UTC'),
      type: 'date',
      sortable: true,
      visible: true
    },
    {
      key: 'expirationDate',
      name: translate('INSTANCE_DETAILS.EXPIRY_DATE_UTC'),
      type: 'date',
      sortable: true,
      visible: true
    }
  ];
  searchTerm: any;
  selectedDatabase: any;
  @Input() selectedTenant:string;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
  public matdialogRef: MatDialogRef<SelectDatabaseComponent>) { }

  ngOnInit(): void {
    this.backupResults = this.data.backupResults;
    this.backupResults?.map(item => item.selected = false);
    this.server = this.data.server;
    this.selectedTenant = this.data?.tenantId;
  }

  // assigning search term
  search(event): void {
    this.searchTerm = event;
  }

  // assigning selected database
  selectDatabase(event): void {
    this.selectedDatabase = event;
  }

  // closing popup after selec button click and sending selected data
  selectClick(): void {
    if (this.selectedDatabase) {
      this.matdialogRef.close(this.selectedDatabase);
    }
  }

  // closing popup on cancel click
  cancel(): void {
    this.matdialogRef.close();
  }
}
